import { Component, TemplateRef, input } from '@angular/core';

@Component({
  selector: 'importer-button-footer',
  templateUrl: './button-footer.component.html',
  styleUrls: ['./button-footer.component.scss'],
  standalone: false
})
export class ButtonFooterComponent {
  readonly buttonsLeftTemplate = input<TemplateRef<unknown>>(undefined);
  readonly buttonsRightTemplate = input<TemplateRef<unknown>>(undefined);
  readonly buttonsCenterTemplate = input<TemplateRef<unknown>>(undefined);
  readonly noHorizontalPadding = input<boolean>(undefined);
}
